export default langsData => [
    {
      path: '/login',
      name: 'login',
      component: ()=> import(/* webpackChunkName: "login" */ "@/views/passport/login/index.vue"),
      meta: {
        title: langsData['login'].title,
      }
    },
    {
      path: '/apple_return_url',
      name: 'apple_return_url',
      component: ()=> import(/* webpackChunkName: "apple_return_url" */ "@/views/passport/login/apple_return_url.vue"),
    }
]